var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card ranking-width" }, [
    _c("ul", { staticClass: "nav nav-tabs justify-content-arround" }, [
      _c("li", { staticClass: "nav-item" }, [
        _c(
          "a",
          {
            staticClass: "nav-link",
            class: { active: _vm.selectedTab === "allSchoolsOfTheMonth" },
            attrs: {
              href: "#",
              "data-toggle": "tab",
              role: "tab",
              "aria-controls": "allSchoolsOfTheMonth",
              "aria-selected": _vm.selectedTab === "allSchoolsOfTheMonth"
            },
            on: {
              click: function($event) {
                _vm.selectedTab = "allSchoolsOfTheMonth"
              }
            }
          },
          [_vm._v(" " + _vm._s(_vm.T.schoolsOfTheMonth) + " ")]
        )
      ]),
      _c("li", { staticClass: "nav-item" }, [
        _c(
          "a",
          {
            staticClass: "nav-link",
            class: { active: _vm.selectedTab === "schoolsOfPreviousMonth" },
            attrs: {
              href: "#",
              "data-toggle": "tab",
              role: "tab",
              "aria-controls": "schoolsOfPreviousMonth",
              "aria-selected": _vm.selectedTab === "schoolsOfPreviousMonth"
            },
            on: {
              click: function($event) {
                _vm.selectedTab = "schoolsOfPreviousMonth"
              }
            }
          },
          [_vm._v(" " + _vm._s(_vm.T.schoolsOfTheMonthRank) + " ")]
        )
      ]),
      _c("li", { staticClass: "nav-item" }, [
        _c(
          "a",
          {
            staticClass: "nav-link",
            class: {
              active: _vm.selectedTab === "candidatesToSchoolOfTheMonth"
            },
            attrs: {
              href: "#",
              "data-toggle": "tab",
              role: "tab",
              "aria-controls": "candidatesToSchoolOfTheMonth",
              "aria-selected":
                _vm.selectedTab === "candidatesToSchoolOfTheMonth"
            },
            on: {
              click: function($event) {
                _vm.selectedTab = "candidatesToSchoolOfTheMonth"
              }
            }
          },
          [_vm._v(" " + _vm._s(_vm.T.schoolsOfTheMonthCandidates) + " ")]
        )
      ])
    ]),
    _vm.isDisabled
      ? _c(
          "div",
          { staticClass: "system-in-maintainance m-5 text-center" },
          [
            _c("omegaup-markdown", {
              attrs: { markdown: _vm.T.schoolOfTheMonthSystemInMaintainance }
            }),
            _c("font-awesome-icon", { attrs: { icon: ["fas", "cogs"] } })
          ],
          1
        )
      : _c("table", { staticClass: "table table-striped table-hover" }, [
          _c("thead", [
            _c(
              "tr",
              [
                _c(
                  "th",
                  { staticClass: "text-center", attrs: { scope: "col" } },
                  [_vm._v(_vm._s(_vm.T.wordsCountryRegion))]
                ),
                _c(
                  "th",
                  { staticClass: "text-center", attrs: { scope: "col" } },
                  [_vm._v(_vm._s(_vm.T.wordsSchool))]
                ),
                _vm.selectedTab === "allSchoolsOfTheMonth"
                  ? _c(
                      "th",
                      { staticClass: "text-center", attrs: { scope: "col" } },
                      [_vm._v(" " + _vm._s(_vm.T.wordsDate) + " ")]
                    )
                  : _vm.selectedTab === "candidatesToSchoolOfTheMonth"
                  ? [
                      _c(
                        "th",
                        { staticClass: "text-center", attrs: { scope: "col" } },
                        [_vm._v(" " + _vm._s(_vm.T.rankScore) + " ")]
                      ),
                      _vm.isMentor
                        ? _c(
                            "th",
                            {
                              staticClass: "text-center",
                              attrs: { scope: "col" }
                            },
                            [_vm._v(" " + _vm._s(_vm.T.wordsActions) + " ")]
                          )
                        : _vm._e()
                    ]
                  : _vm._e()
              ],
              2
            )
          ]),
          _c(
            "tbody",
            _vm._l(_vm.visibleSchools, function(school, index) {
              return _c(
                "tr",
                { key: index },
                [
                  _c(
                    "td",
                    { staticClass: "text-center" },
                    [
                      _c("omegaup-country-flag", {
                        attrs: { country: school.country_id }
                      })
                    ],
                    1
                  ),
                  _c("td", { staticClass: "text-center" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "/schools/profile/" + school.school_id + "/"
                        }
                      },
                      [_vm._v(_vm._s(school.name))]
                    )
                  ]),
                  _vm.selectedTab === "allSchoolsOfTheMonth"
                    ? _c("td", { staticClass: "text-center" }, [
                        _vm._v(" " + _vm._s(school.time) + " ")
                      ])
                    : _vm.selectedTab === "candidatesToSchoolOfTheMonth"
                    ? [
                        _c("td", { staticClass: "text-center" }, [
                          _vm._v(" " + _vm._s(school.score) + " ")
                        ]),
                        _vm.isMentor
                          ? _c("td", { staticClass: "text-center" }, [
                              _vm.canChooseSchool && !_vm.schoolIsSelected
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-sm btn-primary",
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit(
                                            "select-school",
                                            school.school_id
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.T.schoolOfTheMonthChooseAsSchool
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          : _vm._e()
                      ]
                    : _vm._e()
                ],
                2
              )
            }),
            0
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }